/** Shared squad specs — instrument rail + portraits (single source of truth). */

export const SQUAD_ROLES = [
  {
    kind: 'product',
    name: 'Product',
    bandLabel: '1× PRODUCT',
    body:
      'Strategy, research, UX, workshop facilitation, user testing. Translates founder vision into validated product decisions.',
  },
  {
    kind: 'marketing',
    name: 'Marketing',
    bandLabel: '1× MARKETING',
    body:
      'Positioning, demand generation, audience validation, conversion. Finds out if real people actually care.',
  },
  {
    kind: 'tech',
    name: 'Tech',
    bandLabel: '1× TECH',
    body:
      'Prototyping, AI integration, architecture, MVP. Builds fast, lean, only what the evidence justifies.',
  },
];

/** Pyramidion band — accountable seat (not a fourth delivery column). */
export const FOUNDER_OBELISK_LINE =
  'Founder · single accountable seat at the apex. Names and bios after Discovery — not on a landing page.';

/** Rail node at top of squad list — maps to obelisk apex in the instrument graph. */
export const FOUNDER_RAIL = {
  kind: 'founder',
  bandLabel: 'APEX · FOUNDER',
  name: 'Founder',
  body: FOUNDER_OBELISK_LINE,
};
